import type { ReactNode } from 'react';
import { CodeBlock } from './CodeBlock';

const STEPS: Array<{ title: string; body: ReactNode }> = [
  {
    title: 'Bootstrap the account, once per account and region',
    body: <CodeBlock code="npx cdk bootstrap aws://111122223333/us-east-1" />,
  },
  {
    title: 'Create a deploy role',
    body: (
      <p className="muted small">
        GitHub OIDC and a role your workflow assumes — no long-lived AWS keys in your repository.{' '}
        <a href="https://github.com/FutureMoney/fargate-deployer/blob/main/docs/aws-setup.md">
          docs/aws-setup.md
        </a>{' '}
        has the trust policy, the permissions policy and a CloudFormation template that creates
        both. Static access keys are supported too, including temporary credentials and keys that
        chain into a role.
      </p>
    ),
  },
  {
    title: 'Write a manifest and check it',
    body: (
      <CodeBlock code="npx fargate-deployer validate --manifest deploy/production.yaml" />
    ),
  },
  {
    title: 'Add the workflow',
    body: (
      <>
        <CodeBlock
          code={`name: Deploy
on:
  push:
    branches: [main]

permissions:
  contents: read
  id-token: write # required for OIDC

jobs:
  deploy:
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4
      - uses: futuremoney/fargate-deployer@v1
        with:
          manifest: deploy/production.yaml
          role-to-assume: arn:aws:iam::111122223333:role/github-actions-deploy`}
        />
        <p className="muted small" style={{ marginTop: '0.75rem' }}>
          Pin <code>@v1</code> to track every non-breaking release, or an exact tag to hold still.
        </p>
      </>
    ),
  },
];

export function Install() {
  return (
    <section id="quickstart">
      <h2>Quickstart</h2>
      <ol className="steps">
        {STEPS.map((step) => (
          <li key={step.title}>
            <h3>{step.title}</h3>
            {step.body}
          </li>
        ))}
      </ol>
    </section>
  );
}
